import { render, staticRenderFns } from "./LayoutColumnHeader.vue?vue&type=template&id=a30a44ac&"
import script from "./LayoutColumnHeader.vue?vue&type=script&lang=js&"
export * from "./LayoutColumnHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a30a44ac')) {
      api.createRecord('a30a44ac', component.options)
    } else {
      api.reload('a30a44ac', component.options)
    }
    module.hot.accept("./LayoutColumnHeader.vue?vue&type=template&id=a30a44ac&", function () {
      api.rerender('a30a44ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/layout/LayoutColumnHeader.vue"
export default component.exports